export const iconPause={name:"pause",data:'<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="m14 8.96 12 .018V55.04l-12-.018zM38 8.96l12 .018V55.04l-12-.018z"/></svg>'};
